import { render } from "./PolicyDocument2.vue?vue&type=template&id=5b6f20fc&scoped=true"
import script from "./PolicyDocument2.vue?vue&type=script&lang=js"
export * from "./PolicyDocument2.vue?vue&type=script&lang=js"

import "./PolicyDocument2.vue?vue&type=style&index=0&id=5b6f20fc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\oaromasodun\\Desktop\\MarinePortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6f20fc"]])

export default __exports__